/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_OverviewInputs */

const en_settings_nav_overview = /** @type {(inputs: Settings_Nav_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const zh_settings_nav_overview = /** @type {(inputs: Settings_Nav_OverviewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Settings_Nav_OverviewInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_nav_overview = /** @type {((inputs?: Settings_Nav_OverviewInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_OverviewInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_nav_overview(inputs)
	return zh_settings_nav_overview(inputs)
});
export { settings_nav_overview as "settings.nav.overview" }